<template>
	<svg
		width="20"
		height="20"
		viewBox="0 0 24 24"
		fill="currentColor"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M11.5 8C14.15 8 16.55 8.99 18.4 10.6L22 7V16H13L16.62 12.38C15.23 11.22 13.46 10.5 11.5 10.5C7.96 10.5 4.95 12.81 3.9 16L1.53 15.22C2.92 11.03 6.85 8 11.5 8Z"
			fill="currentColor"
		/>
	</svg>
</template>

<script>
export default {};
</script>


